/**
 * Created by shobhitjain on 16/01/20.
 */

import React from 'react';
import classnames from 'classnames';
import style from './index.scss';

const TitleBar = ({ title, noBorderBottom = true, noBorderTop = false }) => {
  return (
    <div className={classnames(style.card, 'mt-3')}>
      <div
        className={classnames(
          style.card_header,
          noBorderBottom ? style.border_radius_bottom_zero : '',
          noBorderTop ? style.border_radius_top_zero : ''
        )}>
        {title}
      </div>
    </div>
  );
};

export default TitleBar;
